module.exports = __webpack_public_path__ + "img/EducationalGroups-x.76fe3300.svg";